export interface CVSSVector {
  AV: "N" | "A" | "L" | "P";
  AC: "L" | "H";
  PR: "N" | "L" | "H";
  UI: "N" | "R";
  S: "U" | "C";
  C: "N" | "L" | "H";
  I: "N" | "L" | "H";
  A: "N" | "L" | "H";
}

export const defaultVector = {
  AV: "N", // Attack Vector: Network
  AC: "L", // Attack Complexity: Low
  PR: "N", // Privileges Required: None
  UI: "N", // User Interaction: None
  S: "U", // Scope: Unchanged
  C: "N", // Confidentiality: None
  I: "N", // Integrity: None
  A: "N", // Availability: None
};

export function parseCVSSVector(vectorString: string): CVSSVector {
  const prefix = "CVSS:3.1/";
  const cleanString = vectorString.startsWith(prefix) ? vectorString.slice(prefix.length) : vectorString;

  const parts = cleanString.split("/");
  const result = {} as CVSSVector;

  for (const part of parts) {
    const [metric, value] = part.split(":");
    switch (metric) {
      case "AV":
        result.AV = value as CVSSVector["AV"];
        break;
      case "AC":
        result.AC = value as CVSSVector["AC"];
        break;
      case "PR":
        result.PR = value as CVSSVector["PR"];
        break;
      case "UI":
        result.UI = value as CVSSVector["UI"];
        break;
      case "S":
        result.S = value as CVSSVector["S"];
        break;
      case "C":
        result.C = value as CVSSVector["C"];
        break;
      case "I":
        result.I = value as CVSSVector["I"];
        break;
      case "A":
        result.A = value as CVSSVector["A"];
        break;
    }
  }

  return result;
}

export function cvssVectorToString(vector: CVSSVector): string {
  return `CVSS:3.1/AV:${vector.AV}/AC:${vector.AC}/PR:${vector.PR}/UI:${vector.UI}/S:${vector.S}/C:${vector.C}/I:${vector.I}/A:${vector.A}`;
}

export function isValidCVSS31Vector(vectorString: string): boolean {
  const prefix = "CVSS:3.1/";

  // Require the standard prefix to confirm the format
  if (!vectorString.startsWith(prefix)) {
    return false;
  }

  // After removing the prefix, we expect 8 metric/value pairs
  const withoutPrefix = vectorString.slice(prefix.length);
  const parts = withoutPrefix.split("/");
  if (parts.length !== 8) {
    return false;
  }

  // Let our existing parser do the heavy lifting
  const parsed = parseCVSSVector(vectorString);

  // Check that all properties are present and not undefined
  if (!parsed.AV || !parsed.AC || !parsed.PR || !parsed.UI || !parsed.S || !parsed.C || !parsed.I || !parsed.A) {
    return false;
  }

  // If all metrics are found with recognized values, the string is valid
  return true;
}
